import React from 'react';
import { ValidationMessage } from './validation-message';
import { FormHelperText } from '@dropbox/dig-components/form_row';
import { FormattedMessage } from 'react-intl';

interface Props {
  id: string;
  required: boolean;
  errorMessage?: string;
}

export function FieldHelperText({ id, required, errorMessage }: Props) {
  if (errorMessage) {
    return <ValidationMessage message={errorMessage} id={`validation_${id}`} />;
  }

  return (
    <FormHelperText variant="default" id={`validation_${id}`}>
      <>
        {required ? (
          <FormattedMessage
            id="c1ccc687d4f3320c7cd2164dd234fce19dff0c45f1cf690e2f3107694a824a99"
            defaultMessage="Required field."
            description="Drawer header message indicating a required field"
          />
        ) : (
          <FormattedMessage
            id="597cfb067a7a2337668c3920fd75014079a39f5fa60c4ac3462c759ec90d6db1"
            defaultMessage="Optional field."
            description="Drawer header message indicating an optional field"
          />
        )}
      </>
    </FormHelperText>
  );
}
